import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapProducts } from '../../mappers';
import { IAnalyticsState } from '../../types/analytics';
import { TReduxActions } from '../../types/redux';

const defaultState: IAnalyticsState = {
  products: [],
  productsById: {},
};

export function analyticsReducer(state: IAnalyticsState = defaultState, action: TReduxActions): IAnalyticsState {
  switch (action.type) {
    case EPromosActionTypes.Success: {
      const newProducts = mapProducts(action.payload);

      return { ...state, ...newProducts };
    }

    case EPaginationActionTypes.Success: {
      const newProducts = mapProducts(action.payload);

      return {
        ...state,
        products: state.products.concat(newProducts.products),
        productsById: Object.assign({}, state.productsById, newProducts.productsById),
      };
    }

    default:
      return state;
  }
}
